export const apiConstants = {
  AUTH: {
    LOGIN: 'Auth/Login',
    LOGOUT: 'Auth/Logout',
    REGISTER: 'Auth/RegisterUser',
    FORGOT_PASSWORD: 'Auth/ForgotPassword',
    RESET_PASSWORD: 'Auth/ResetPassword',
    ACTIVATE_USER: 'Auth/ActivateUser',
    RESEND_ACTIVATION_CODE: 'Auth/ResendActivationCode',
    VALIDATE_CODE: 'Auth/ValidatePasswordResetCode',
    SEARCH_ADDRESS: 'Auth/SearchAddresses',
    TOKEN_DETAILS: 'Auth/tokenDetail',
    WAITING_USER: 'Auth/WaitingUser',
    ADDRESS_BY_PLACE_ID: 'Auth/GetAddressByPlaceId',
    ADD_FCM_TOKEN: 'Auth/AddFcmToken',
    REGISTER_USER_VIA_THIRD_PARTY_APP: 'Auth/RegisterUserViaThirdPartyApp',
    ACCOUNT_EXISTENCE_CHECK: 'Auth/CheckAccountExistence',
    VERIFY_SECURITY_CODE: 'Auth/VerifySecurityCode',
    LOGIN_VIA_OTP: 'Auth/LoginViaOTP',
  },
  USER: {
    GET_USER_BY_ID: 'Users/GetUserById',
    UPDATE_USER: 'Users/UpdateUser',
    CHANGE_PASSWORD: 'Users/ChangePassword',
    DELETE_USER: 'Users/DeleteUserById',
    SAVE_USER_RATING: 'Users/SaveUserRating',
    GET_REGISTERED_USER: 'Users/GetRegisteredUser',
    GET_WAITING_USER: 'Users/GetWaitingUser',
    DELETE_WAITING_USER: 'Users/DeleteWaitingUserById',
    SAVE_USER_RATING: 'Users/SaveUserRating',
    GET_REGISTERED_USER: 'Users/GetRegisteredUser',
    GET_WAITING_USER: 'Users/GetWaitingUser',
    DELETE_WAITING_USER: 'Users/DeleteWaitingUserById',
    SEND_FEEDBACK: 'Users/SendFeedback',
    ADMIN_ALL_FEEDBACK: 'Users/GetSendFeedback',
    FEEDBACK_BY_ID: 'Users/GetSendFeedbackById',
    DELETE_FEEDBACK_BY_ID: 'Users/DeleteSendFeedbackById',
    UPDATE_USER_DETAILS: 'Users/UpdateDetails',
    UPDATE_AVAILABILITY: "Users/UpdateAvailability",
    GET_REGISTERED_COMPANIES: "Users/GetRegisteredCompanies",
    VERIFY_USER: "Users/VerifyUser",
    SWITCH_ROLE: "Users/SwitchRole",
    ADD_ROLE: "Users/AddRole",
    GET_USER_RATING: 'Users/GetUserRating',
    GET_ADMIN_DASHBOARD: "Users/GetAdminDashboard",
    UPDATE_SERVICE_REQUEST_OPTION: "Users/UpdateServiceRequestOption",
    GET_INVITE_AND_REGISTERED_USERS: "Users/GetInviteAndRegisteredUsers",
    UPDATE_USER_CREDITS: "Users/UpdateUserCredits",
    GET_CREDIT_HISTORY: "Users/GetCreditHistory",
    GET_USER_LINK: "Users/GetGuestUserLink",
    DELETE_GUEST_USER_LINK: "Users/DeleteGuestUserLink",
    CREATE_UPDATE_GUEST_USER_LINK: "Users/CreateUpdateGuestUserLink",
    UPDATE_PRO_OPTION: "Users/UpdateProOption",
  },
  PROFESSIONAL: {
    SAVE_WORK_INFORMATION: 'Professional/SaveWorkInformation',
    GET_WORK_INFORMATION: 'Professional/GetWorkInformation',
    SAVE_EXPERTISE: 'Professional/SaveExpertise',
    DELETE_EXPERTISE: 'Professional/DeleteExpertiseById',
    SEARCH_PRO: "Professional/SearchProfessional",
    UPLOAD_DOCUMENTS: "Professional/UploadDocuments",
    UPLOAD_DOCUMENT: "Professional/UploadDocument",
    GET_DOCUMENTS: "Professional/GetDocuments",
    DELETE_DOCUMENT: 'Professional/DeleteDocumentById',

  },

  VIDEO: {
    SEND_LINK: 'Video/SendLink',
    CALL_HISTORY: 'Video/CallHistory',
    RESEND_VIDEO_LINK: 'Video/ResendVideoLink',
    DELETE_CALL_HISTORY: 'Video/DeleteCallHistory',
    CALL_DETAILS: 'Video/CallDetails',
    BULK_DELETE: 'Video/BulkDeleteCallHistory',
    CALL_NOTE: "Video/CallNote",
    CALL_NOTE_DETAILS: "Video/CallNoteDetails",
    CALL_REQUESTS: 'Video/CallRequests',
    DISCONNECT_CALL: 'Video/DisconnectCall',
    DELETE_CALL_LOG_NOTE_BY_ID: 'Video/DeleteCallLogNoteById',
    SAVE_CALL_DURATION: 'Video/SaveCallDuration',
    GET_PARTICIPANTS: "Video/GetParticipants",
    UPDATE_CALL_NOTE: "Video/UpdateCallNote",
    GET_CALL_RECORDINGS: "Video/GetCallRecordings",
    DELETE_CALL_RECORDING: "Video/DeleteCallRecording",
    GET_COMPOSE_RECORDINGS: "Video/GetComposeRecordings",
    CREATE_COMPOSE_RECORDING: "Video/CreateComposeRecording",
    DELETE_COMPOSE_RECORDING: "Video/DeleteComposeRecording",
  },

  INVITATION: {
    INVITE: 'Invitation/SendInvitation',
  },

  COUNTRY_CODE: {
    GET_COUNTRY_CODE: 'Country/GetCountry',
    GET_STATE_BY_COUNTRY_ID: 'Country/GetStatesByCountryId',
    GET_COUNTRY_BY_ID: 'Country/GetCountryById',
  },

  NOTIFICATION: {
    UNREAD_NOTIFICATION_COUNT: 'Notifications/UnreadNotificationCount',
    USER_NOTIFICATION: 'Notifications/UserNotifications',
    NOTIFICATION_DETAILS: 'Notifications/NotificationDetails',
    DELETE_NOTIFICATION: 'Notifications/DeleteNotification',
    BULK_READ_DELETE: "Notifications/BulkReadDeleteNotifications"
  },

  OBJECT_RECOGNITION: {
    RECOGNITION: 'Object/Recognition',
    USER_FEEDBACK: 'Object/UserFeedback',
    ADD_SUB_CATEGORY: 'Object/addSubCategory',
    ADD_PRODUCT_TYPE: 'Object/addObjectType',
    ADD_BRAND: 'Object/addBrand',
    GET_CATEGORY: 'Object/GetCategories',
    GET_SUB_CATEGORY: 'Object/GetSubCategoriesByCategoryId',
    GET_PRODUCT_TYPE: 'Object/GetObjectTypesByCategoryId',
    GET_BRAND_FROM_PRODUCT_ID: 'Object/GetObjectBrandByTypeId',
    SEARCH_RECOGNITION: 'Object/UserFeedbackGlobalSearch',
    OCR: 'Object/OCR',
    GET_ALL_PRODUCT_TYPE_LIST: 'Object/GetAllProductTypeList',
    SOURCING_INFO_FROM_DEVICE_MODEL: 'Object/SourcingInfoFromDeviceModel',
    GOOGLE_SOURCING_INFO_FROM_DEVICE_MODEL: 'Object/GoogleSourcingInfoFromDeviceModel',
    GET_AI_SUGGESTIONS: 'Object/GetAISuggestions',
    CROP_BOX: 'Object/CropBox',
  },

  JOIN: {
    JOIN_CALL: "Video/Join"
  },
  TICKET: {
    CREATE_TICKET: "ServiceRequest/Create",
    GET_TICKET_BY_ID: "ServiceRequest/GetTicketById",
    GET_CALL_REQUESTS_FOR_TICKET: 'ServiceRequest/GetCallRequestsForTicket',
    SEND_CALL_REQUEST_TICKET: 'ServiceRequest/SendCallRequest',
    GET_USER_TICKETS: "ServiceRequest/GetUserTickets",
    GET_ALL_TICKETS: "ServiceRequest/GetAllTickets",
    GET_TICKETS_FOR_PROFESSIONAL: "ServiceRequest/GetTicketsForProfessional",
    ACCEPT_REJECT_REQUEST: 'ServiceRequest/AcceptRejectRequest',
    GET_TICKETS: 'ServiceRequest/GetTickets',
    UPDATE_TICKET_DETAIL: 'ServiceRequest/UpdateTicketDetail',
    CONNECT_TO_PRO: 'ServiceRequest/ConnectToPro',
    UPDATE_TICKET_STATUS: 'ServiceRequest/UpdateTicketStatus',
    GET_PURCHASE_LIST: 'ServiceRequest/GetPurchaseList',
    CREATE_PURCHASE_ITEM: 'ServiceRequest/CreatePurchaseItem',
    UPDATE_PURCHASE_ITEM: 'ServiceRequest/UpdatePurchaseItem',
    DELETE_PURCHASE_ITEM: 'ServiceRequest/DeletePurchaseItem',
    SHARE_PURCHASE_LIST: 'ServiceRequest/SharePurchaseList',
    SHARE_SERVICE_REQUEST: 'ServiceRequest/ShareServiceRequest',
    GET_SHARED_SERVICE_REQUEST: 'ServiceRequest/GetSharedServiceRequest',
    GET_COUNTERS: "ServiceRequest/GetServiceRequestCounters",
    GET_SERVICE_REQUEST_HISTORY: "ServiceRequest/GetServiceRequestHistory",
    GET_NOTES_PURCHASE_LIST_CALLS_COUNTERS: "ServiceRequest/GetNotesPurchaseListCallSCounters",
    CREATE_VIA_ROLE: 'ServiceRequest/CreateViaRole',
    RE_ASSIGN_VIA_ROLE: 'ServiceRequest/ReAssignViaRole',
    ACCEPT_ASSIGNED_TICKET: 'ServiceRequest/AcceptAssignedTicket',
    GET_ACTIVE_CALLS: 'ServiceRequest/GetActiveCalls',
    CREATE_UPDATE_PROJECT: 'ServiceRequest/CreateUpdateProject',
    SAVE_PROJECT_SUGGESTIONS: 'ServiceRequest/SaveProjectSuggestions',
    GET_SAVED_PROJECT_SUGGESTIONS: 'ServiceRequest/GetSavedProjectSuggestions',
    DELETE_PROJECT_SUGGESTION: 'ServiceRequest/DeleteProjectSuggestion',
    GET_PROJECTS: 'ServiceRequest/GetProjects',
    DELETE_PROJECT_DETAIL: 'ServiceRequest/DeleteProjectDetail',
    GET_PROJECT_DETAIL: 'ServiceRequest/GetProjectDetail',
    BULK_DELETE_PROJECT_STEPS: 'ServiceRequest/BulkDeleteProjectSteps',
    GET_CHAT_HISTORY: 'ServiceRequest/GetChatHistory',
    CREATE_UPDATE_CHAT_HISTORY: 'ServiceRequest/CreateUpdateChatHistory',
    DELETE_PROJECT_CHAT_HISTORY: 'ServiceRequest/DeleteProjectChatHistory',
    TRIGGER_NOTIFICATION_TO_PRO: 'ServiceRequest/TriggerNotificationToPro',
    UPDATE_TICKET_SUMMARY: 'ServiceRequest/UpdateTicketSummary',
    DELETE_TICKET_BY_ID: 'ServiceRequest/DeleteTicketById',
    HIDE_SERVICE_REQUEST: 'ServiceRequest/HideServiceRequest',
    CREATE_BID: 'ServiceRequest/CreateBid',
    CREATE_TICKET_THREAD: 'ServiceRequest/CreateTicketThread',
    GET_TICKET_MESSAGE_THREAD: 'ServiceRequest/GetTicketMessageThread',
    DELETE_TICKET_THREAD_BY_ID: 'ServiceRequest/DeleteTicketThreadById',
    UPDATE_TICKET_THREAD_BY_ID: 'ServiceRequest/UpdateTicketThreadById',
  },
  REPORT: {
    SEND_REPORT: 'DocumentGenerator/DiagnosisReport',
    GET_REPORT_PDF: 'DocumentGenerator/GetPdf',
  },
  PAYMENT_GATEWAY: {
    CREATE_PAYMENT_METHOD: 'PaymentGateway/CreatePaymentMethod',
    GET_PAYMENT_METHOD_LIST_BY_CUSTOMER_ID: 'PaymentGateway/GetPaymentMethodListByCustomerId',
    CREATE_PAYMENT_METHOD_BY_CUSTOMER_ID: 'PaymentGateway/CreatePaymentMethodByCustomerId',
    UPDATE_PAYMENT_METHOD_BY_ID: 'PaymentGateway/UpdatePaymentMethodById',
    DELETE_PAYMENT_METHOD_BY_ID: 'PaymentGateway/DeletePaymentMethodById',
    DELETE_CONNECTED_ACCOUNT_BY_ID: 'PaymentGateway/DeleteConnectedAccountById',
    CREATE_CONNECTED_ACCOUNT: 'PaymentGateway/CreateConnectedAccount',
    GET_CONNECTED_ACCOUNT_STATUS_BY_ID: 'PaymentGateway/GetConnectedAccountStatusById',
    GET_CONNECTED_ACCOUNT_LINK_BY_ID: 'PaymentGateway/GetConnectedAccountLinkById',
    SET_DEFAULT_PAYMENT_METHOD_BY_ID: 'PaymentGateway/SetDefaultPaymentMethodById',
    GET_PRODUCTS_LIST: 'PaymentGateway/GetProductsList',
    CREATE_SUBSCRIPTION: 'PaymentGateway/CreateSubscription',
    GET_SUBSCRIPTION_STATUS_BY_ID: 'PaymentGateway/GetSubscriptionStatusById',
    CANCEL_SUBSCRIPTION_BY_ID: 'PaymentGateway/CancelSubscriptionById',
    UPDATE_SUBSCRIPTION_BY_ID: 'PaymentGateway/UpdateSubscriptionById',
    CHARGE_PROFESSIONAL_BY_ID: 'PaymentGateway/ChargeProfessionalById',
    GET_PAYMENT_METHOD_SUPPORTED_LIST: 'PaymentGateway/GetPaymentMethodSupportedList',
    CHECK_PROMO_CODE: 'PaymentGateway/CheckPromoCode',
    GET_SUBSCRIPTION_TRANSACTION_LIST: 'PaymentGateway/GetSubscriptionTransactionList',
    GET_CALL_LOG_TRANSACTION_LIST: 'PaymentGateway/GetCallLogTransactionList',
    GET_PAYOUT_LIST_BY_ID: 'PaymentGateway/GetPayoutListById',
    GET_CONNECTED_ACCOUNT_BALANCE_BY_ID: 'PaymentGateway/GetConnectedAccountBalanceById',
    GET_PAYMENT_LIST: 'PaymentGateway/GetPaymentList',
    GET_CONNECTED_ACCOUNT_BALANCE_TRANSACTION_LIST_BY_ID: 'PaymentGateway/GetConnectedAccountBalanceTransactionListById',
    CREATE_PAYOUT: 'PaymentGateway/CreatePayout',
    GET_PAYMENT_CONFIG: 'PaymentGateway/GetPaymentConfig',
    RAISE_REFUND: 'PaymentGateway/RaiseRefund',
    GET_REFUND_LIST_VIA_STATUS: 'PaymentGateway/GetRefundListViaStatus',
    CREATE_REFUND: 'PaymentGateway/CreateRefund',
    CREATE_TRANSFER: "PaymentGateway/CreateTransfer",
    GET_EARNINGS_INFORMATION: "PaymentGateway/GetEarningsInformation",
    GET_PAYMENT_TRANSACTION_LIST: "PaymentGateway/GetPaymentTransactionList",
    GET_AFFILIATE_PROGRAM_DETAILS: "PaymentGateway/GetAffiliateProgramDetails",
    UPDATE_AFFILIATE_PROGRAM_DETAILS: "PaymentGateway/UpdateAffiliateProgramDetails",
    GET_PRICE_PER_QUANTITY: "PaymentGateway/GetPricePerQuantity",
  },
  COMPANIES: {
    GET_REGISTERED_COMPANIES: "CompanyManagement/GetRegisteredCompanies",
    GET_COMPANIES_BY_ID: "CompanyManagement/GetCompanyById",
    ADD_COMPANIES: "CompanyManagement/Register",
    DELETE_COMPANY: "CompanyManagement/DeleteCompanyById",
    UPDATE_COMPANY: "CompanyManagement/UpdateDetail",
    USER_ADD_COMPANY: "CompanyManagement/AddCompany",
    SEND_COMPANY_INVITATION: "CompanyManagement/SendCompanyInvitation",
    ACCEPT_COMPANY_INVITATION: 'CompanyManagement/AcceptCompanyInvitation',
    JOIN_COMPANY: "CompanyManagement/JoinCompany",
    ACCEPT_COMPANY_JOIN_REQUEST: "CompanyManagement/AcceptCompanyJoinRequest",
    GET_COMPANY_INVITATION: "CompanyManagement/GetCompanyInvitation",
    RESEND_COMPANY_INVITATION: "CompanyManagement/ResendCompanyInvitation",
    SHARE_COMPANY_CODE: "CompanyManagement/ShareCompanyCode",
    DELETE_COMPANY_INVITATION: "CompanyManagement/DeleteCompanyInvitation",
    CANCEL_COMPANY_INVITATION: "CompanyManagement/CancelCompanyInvitation",
  },
  PERMISSIONS: {
    GET_PERMISSIONS: "Users/GetPermissionByRole",
    UPDATE_PERMISSIONS: "Users/AssignPermissionToRole"
  },
  HOME_MAINTENANCE: {
    GET_HOME_AREA_LIST: "HomeMaintenance/GetHomeAreaList",
    ADD_NEW_HOME_AREA: "HomeMaintenance/AddNewHomeArea",
    EDIT_HOME_AREA_LIST: "HomeMaintenance/EditHomeAreaList",
    ADD_UPDATE_INVENTORY_ITEM: "HomeMaintenance/AddUpdateInventoryItem",
    DELETE_INVENTORY_ITEM: "HomeMaintenance/DeleteInventoryItem",
    ADD_UPDATE_MAINTENANCE_PLAN: "HomeMaintenance/AddUpdateMaintenancePlan",
    START_STOP_CHECKING_ITEM: "HomeMaintenance/StartStopCheckingItem",
    GET_CHECKUP_REPORT: "HomeMaintenance/GetCheckupReport",
    GET_HOME_MAINTENANCE_PLANS: "HomeMaintenance/GetHomeMaintenancePlans",
    DELETE_MAINTENANCE_PLAN: "HomeMaintenance/DeleteMaintenancePlan",
    UPDATE_MAINTENANCE_PLAN_STATUS: "HomeMaintenance/UpdateMaintenancePlanStatus",
    DELETE_NEW_HOME_AREA: "HomeMaintenance/DeleteNewHomeArea",
    RESET_HOME_SETUP: "HomeMaintenance/ResetHomeSetup"
  },
  PROMOCODE: {
    GET_PROMOCODE_LIST: "PaymentGateway/GetPromocodes",
    PROMOCODE_BY_ID: "PaymentGateway/GetPromocodeById",
    ADD_OR_UPDATE_PROMOCODE: "PaymentGateway/AddUpdatePromocode",
    DELETE_PROMOCODE: "PaymentGateway/DeletePromocode"
  },
  MESSAGING: {
    SEND_PUSH_NOTIFICATION: "Messaging/SendPushNotification",
    SEND_EMAIL: "Messaging/SendEmail",
    SEND_TEXT_MESSAGE: "Messaging/SendTextMessage",
    SEND_PRO_CODE_INVITE_LINK: "Messaging/SendProCodeInviteLink",
  },
  GUEST_USERS: {
    GUEST_HOMEOWNER_FORUM: "GuestUsers/GuestHomeownerForum",
  }
}
